module.exports = __webpack_public_path__ + "static/media/nwt.aadc15be.jpg";